// Install-time placeholder hostname (e.g. `AMAZON_RFD4.farmersfridge.chi`) —
// these fridges are unreachable until the IP is configured in CMS.
export const PLACEHOLDER_IP_MARKER = 'farmersfridge.chi';

/** @returns {boolean} true when `ip` is a placeholder rather than a real address. */
export function isPlaceholderIp(ip) {
  return typeof ip === 'string' && ip.includes(PLACEHOLDER_IP_MARKER);
}
